import React, { FunctionComponent, useEffect, useRef, useState } from 'react'

import WebcamModule from '../Module'
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown'
import { MediaSourceSelectPropTypes } from '../types'
import { hapticEffects } from '../../../lib/hapticEffects'
import style from './styles.module.scss'
import useSurveyLocale from '../../locale/useSurveyLocale'
import useInterfaceLocale from '../../locale/useInterfaceLocale'

type ListItemType = {
  code: string
  name: string
}

const MediaSourceSelect: FunctionComponent<MediaSourceSelectPropTypes> = ({
  type,
  className
}: MediaSourceSelectPropTypes) => {
  const [value, setValue] = useState<ListItemType>(null)
  const { localeOptions } = useInterfaceLocale()
  const list = useRef<ListItemType[]>([])
  const { t } = useSurveyLocale()

  if (list.current.length != WebcamModule.sourceList(type).length) {
    list.current = WebcamModule.sourceList(type).map((device: MediaDeviceInfo, i: number) => {
      return {
        code: device.deviceId,
        name: device.label || `${t('questions', 'vr', 'audio' == type ? 'microphone' : 'camera')} #${i + 1}`
      }
    })
    const val = list.current.find(
      el => el.code == ('audio' == type ? WebcamModule.audioDevice : WebcamModule.videoDevice)?.deviceId
    )
    setValue(val)
  }

  useEffect(
    () =>
      WebcamModule.onUpdate(() => {
        const val = list.current.find(
          el => el.code == ('audio' == type ? WebcamModule.audioDevice : WebcamModule.videoDevice)?.deviceId
        )
        setValue(val)
      }),
    [type]
  )

  const onChange = (event: DropdownChangeParams) => {
    const selectedDevice = WebcamModule.sourceList(type).find(
      device => device.deviceId === (event.value as ListItemType).code
    )
    if ('audio' == type) WebcamModule.audioDevice = selectedDevice
    else WebcamModule.videoDevice = selectedDevice
  }

  const icon = (
    <>{'video' == type ? <i className="icon-aytmfd-qvideoresponse" /> : <i className="icon-aytmfd-microphone" />}</>
  )

  return (
    <>
      {WebcamModule.sourceList(type).length && !WebcamModule.blind ? (
        <Dropdown
          ariaLabel={t('questions', 'ir', 'selectMediaSource')}
          data-testid="SW-MediaSourceSelect"
          options={list.current}
          className={className}
          optionLabel="name"
          onChange={onChange}
          onFocus={() => hapticEffects.soft()}
          valueTemplate={(option: ListItemType) => (
            <span className={localeOptions.rtl ? style.inputSelectedRTL : style.inputSelected}>
              {icon}
              {option?.name}
            </span>
          )}
          value={value}
        />
      ) : (
        <div className={`${style.inputDiv} ${localeOptions.rtl && style.inputDivRTL}`}>
          {icon}
          {t('questions', 'ir', 'noWebCam')}
        </div>
      )}
    </>
  )
}

export default MediaSourceSelect
